<template>
    <main>
        <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>
        <div class="row">
          <div class="col s12">En desarrollo...</div>
        </div>
                    <!-- <div class="row">
                      <div class="col l4 input-field">
                        <inncosys-select :data-set-ready="storesDataSetReady" v-model="selectedStore" label="Sucursal" first-option-message="Selecciona una sucursal">
                                <option v-for="store in stores" v-bind:key="store.id" >
                                    {{store.name}}
                                </option>
                            </inncosys-select>
                      </div>

                      <div class="col l2 input-field">
                        
                        <inncosys-select id="numAnio" v-model="numAnio" :dataSetReady="true" label="Año">
                          <option v-for="year in years" v-bind:key="year" >{{year}}</option>
                        </inncosys-select>

                      </div>
                      <div class="col l2 input-field hide-on-small-only">
                          <inncosys-select id="numAnio" v-model="numSemana" :dataSetReady="true" label="Semana">
                          <option v-for="week in weeks" v-bind:key="week" >{{week}}</option>
                        </inncosys-select>
                    
                        
                      </div>
                      <div class="col l2 input-field show-on-small hide-on-med-and-up">
                        <input placeholder="32" id="numSemana" type="number" class="validate" v-model="numSemana" >
                        <label for="numSemana">N° Semana</label>
                      </div>
                      <div class="col l2 input-field  valign-wrapper">
                        <p class="center-align">{{fechaConsultaInicio | dateFilter}}</p>
                      </div>
                      <div class="col l2 input-field valign-wrapper">
                        <p class="center-align">{{fechaConsultaFin | dateFilter}}</p>
                      </div>
                </div> 
          
        <div class="row">
            <div class="col l12 s12">
                <div >
                    <datatable title="Resultados Indicadores" :columns="columns" :rows="rows"></datatable>
                </div>
            </div>
        </div>
        -->
    </main>
</template>
<script>
import Breadcrumbs from "../../../components/commun/Breadcrumbs.vue";
import Select from "../../../components/commun/forms/Select.vue";
import DatePicker from "../../../components/commun/forms/DatePicker.vue";
import DataTable from 'vue-materialize-datatable';
import axios from "axios";
const moment = require("moment");
export default {
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysSelect: Select,
    inncosysDatePicker: DatePicker,
    datatable: DataTable
  },
  created() {
    for (var i = moment().year(); i > moment().year() - 5; i--) {
      this.years.push(i);
    }
    for (var i = 1; i < 54; i++) {
      this.weeks.push(i);
    }
  },
  filters: {
    dateFilter(value) {
      if (!value) return "";
      return moment(value).format("DD-MM-YYYY");
    }
  },
  data() {
    return {
      pathHistory: [
        { name: "Inicio", route: "/" },
        {
          name: "Tablero Operaciones",
          route: "/tablero-operaciones/comercial"
        },
        { name: "Mantenimiento", route: "/tablero-operaciones/mantenimiento" }
      ],
      numSemana: 1,
      numAnio: moment().year(),
      years: [],
      weeks: [],
      stores: [],
      storesDataSetReady: false,
      selectedStore: "",
      fechaConsulta: new Date(),

      fechaConsultaInicio: new Date(),
      fechaConsultaFin: new Date(),
      columns: [
        {
          label: "Nombre", // Column name
          field: "nombre", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "UM", // Column name
          field: "um", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "Frecuencia", // Column name
          field: "frecuencia", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "PB", // Column name
          field: "pb", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "Objetivo", // Column name
          field: "objetivo", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        },
        {
          label: "Real", // Column name
          field: "real", // Field name from row
          numeric: false, // Affects sorting
          html: false // Escapes output if false.
        }
      ],
      rows: []
    };
  },
  methods: {
    getStores() {
      axios
        .get("stores?fields=all")
        .then(res => {
          console.log(res);
          this.stores = res.data;
          this.storesDataSetReady = true;
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    getInvoices() {
      axios
        .get("operating?fields=all")
        .then(res => {
          console.log(res.data);
          res.data.forEach(invoice => {
            this.rows.push({
              real: invoice.amount_total,
              nombre: invoice.date_invoice
            });
          });
        })
        .catch(error => {
          console.log(error.response);
        });
    }
  },
  created() {
    this.getStores();
    this.getInvoices();
  }
};
</script>
<style scoped>
</style>
